import React from 'react';
import ConnectionModel, {
  ConnectionResponseType,
  ConnectionKind,
} from '@mm/state/model/ConnectionModel';
import PrimarySelect from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';

export const RESPONSE_TYPE_OPTIONS = {
  [ConnectionResponseType.NONE]: {
    id: ConnectionResponseType.NONE,
    key: ConnectionResponseType.NONE,
    name: 'None',
  },
  [ConnectionResponseType.SAVE_ATTRIBUTES]: {
    id: ConnectionResponseType.SAVE_ATTRIBUTES,
    key: ConnectionResponseType.SAVE_ATTRIBUTES,
    name: 'Attributes to save',
  },
  [ConnectionResponseType.MESSENGER_JSON]: {
    id: ConnectionResponseType.MESSENGER_JSON,
    key: ConnectionResponseType.MESSENGER_JSON,
    name: 'Messenger JSON to Display',
  },
};

type Props = {
  connection: ConnectionModel;
  onResponseTypeChange: (requestType: ConnectionResponseType) => void;
  customOptionsPosition?: 'top' | 'bottom';
};

export const EditResponseType = ({
  connection,
  onResponseTypeChange,
  customOptionsPosition,
}: Props) => {
  const allResponseTypes = Object.values(RESPONSE_TYPE_OPTIONS);
  const filteredResponseTypes =
    connection.kind === ConnectionKind.AUDIENCE
      ? Object.values(RESPONSE_TYPE_OPTIONS).filter(
          responseType =>
            responseType.id !== ConnectionResponseType.MESSENGER_JSON,
        )
      : allResponseTypes;

  return (
    <>
      <div className="edit-connection-panel__title">
        What to do with JSON response
      </div>
      <PrimarySelect
        className="edit-connection-panel__select"
        options={filteredResponseTypes}
        value={RESPONSE_TYPE_OPTIONS[connection.responseType]}
        onChange={responseType =>
          onResponseTypeChange(responseType.id as ConnectionResponseType)
        }
        customDropdownStyles={{ zIndex: '1000003' }}
        customOptionsPosition={customOptionsPosition}
      />
    </>
  );
};

export default EditResponseType;
